import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClientJsonpModule  } from '@angular/Common/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AccountCreationComponent } from "./account-creation.component";

import { AccountCreationRouting } from './account-creation.route';
import { Ng2SelectModule } from "../../core/ng2-select-ext/ng2-select.module";
import { DialogModule } from "../../core/dialog/dialog.module";

import { TextMaskModule } from 'angular2-text-mask';
import { AccountCreationService } from './services/account-creation.service';


import { ValidationModule } from "../../core/custom-validation/validation.module";



@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        HttpClientJsonpModule ,
        ReactiveFormsModule,
        AccountCreationRouting,
        TextMaskModule,
        ValidationModule,
        DialogModule,
        Ng2SelectModule,
    ],
    declarations: [ 
        AccountCreationComponent,
      
    ],
    providers: [AccountCreationService,
        { provide: LocationStrategy,
         useClass: HashLocationStrategy
        },
        {
            provide: 'AppData',
            useValue: (<any> window).APP_DATA 
        }],
    bootstrap: [AccountCreationComponent],
    exports: [
        AccountCreationComponent
    ]
})

export class AccountCreationModule {
//provide: 'AppData', useValue: (<any> window).APP_DATA 
}

